"use strict";

import angular from "angular";

angular.module("nucont.accounting.group").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.group.demonstrationsRedirect", {
            url: "/demonstracoes-redirect",
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-company-demonstrations" */ "../../company/demonstrations/demonstrations.entry"
                ).then(() =>
                    Promise.all([
                        $ocLazyLoad.inject("nucont.accounting.company.demonstrations"),
                        $ocLazyLoad.inject("nucont.accounting.company.showtime")
                    ])
                );
            },
            views: {
                "admin@nucont.accounting": {
                    component: "demonstrationsRedirectComponent",
                    bindings: { companyData: "groupData" }
                }
            }
        })
        .state("nucont.accounting.group.demonstrations.dre", {
            url: "/DRE/:date/:view",
            views: {
                "demonstrationView@nucont.accounting.group.demonstrations": {
                    component: "demonstrationsDreComponent",
                    bindings: { companyData: "groupData" }
                }
            },
            params: {
                demonstration: { value: "DRE", dynamic: false },
                date: { value: null, dynamic: true },
                view: { value: "mensal", dynamic: true }
            },
            bodyClass: "dre-module"
        })
        .state("nucont.accounting.group.demonstrations.balancesheet", {
            url: "/balancete/:date",
            views: {
                "demonstrationView@nucont.accounting.group.demonstrations": {
                    component: "balanceSheetComponent",
                    bindings: { companyData: "groupData" }
                }
            },
            params: {
                demonstration: { value: "balancete", dynamic: false },
                date: { value: null, dynamic: true }
            },
            bodyClass: "dre-module"
        })
        .state("nucont.accounting.group.demonstrations.balance", {
            url: "/balanco/:date/:view",
            views: {
                "demonstrationView@nucont.accounting.group.demonstrations": {
                    component: "balanceComponent",
                    bindings: { companyData: "groupData" }
                }
            },
            params: {
                demonstration: { value: "balanco", dynamic: false },
                date: { value: null, dynamic: true },
                view: { value: null, dynamic: true }
            },
            bodyClass: "balance-module"
        });
}
